import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

function ProfileDetails() {
  const { profileId } = useParams();
  const [profilePic, setProfilePic] = useState(null);
  const [formData, setFormData] = useState({
    nom: 'Entrer un nom',
    url: 'https://mir-s3-cdn-cf.behance.net/project_modules/disp/84c20033850498.56ba69ac290ea.png'
  });
  const [message, setMessage] = useState('');
  const [isEditingName, setIsEditingName] = useState(false);
  const [isImageOptionsVisible, setIsImageOptionsVisible] = useState(false);

  const imageOptions = [
    'https://mir-s3-cdn-cf.behance.net/project_modules/disp/84c20033850498.56ba69ac290ea.png',
    'https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bdc9a33850498.56ba69ac2ba5b.png',
    'https://mir-s3-cdn-cf.behance.net/project_modules/disp/bf6e4a33850498.56ba69ac3064f.png',
  ];

  useEffect(() => {
    const fetchPicProfile = async () => {
      try {
        const response = await fetch(`/profile/profile-details/${profileId}`);
        if (response.ok) {
          const profilePicData = await response.json();
          setProfilePic(profilePicData);
          setFormData({
            nom: profilePicData.nom,
            url: profilePicData.url,
          });
        } else {
          console.error(`Error fetching profile picture: ${response.status}`);
        }
      } catch (error) {
        console.error('Unexpected error fetching profile picture:', error);
      }
    };

    if (profileId) {
      fetchPicProfile();
    } else {
      console.error('Aucun profileId trouvé.');
      // Vous pouvez ajouter une gestion d'erreur plus explicite ici
    }
  }, [profileId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/profile/update-profile/${profileId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const updatedProfile = await response.json();
        setProfilePic(updatedProfile);
        setMessage('Profil modifié avec succès.');
      } else {
        throw new Error('La modification du profil a échoué.');
      }
    } catch (error) {
      setMessage('Erreur lors de la modification du profil:', error.message);
    }
  };

  const handleNameChange = (e) => {
    const newName = e.target.value;
    setFormData({ ...formData, nom: newName });
  };

  const handleImageClick = () => {
    setIsImageOptionsVisible(!isImageOptionsVisible);
  };

  const handleImageOptionClick = (imageUrl) => {
    setFormData({ ...formData, url: imageUrl });
    setIsImageOptionsVisible(false);
  };

  return (
    <section className="container_news create">
      <div className="container_connexion create-profile">
        <h1>Modifier un profil</h1>
        <form method="POST" onSubmit={handleSubmit} className="create-form">
          <div className="preview">
            <img
              src={formData.url}
              alt="preview_pic_profile"
              onClick={handleImageClick}
            />
            {isEditingName ? (
              <input
                type="text"
                value={formData.nom}
                onChange={handleNameChange}
                onBlur={() => setIsEditingName(false)}
                autoFocus
              />
            ) : (
              <h5 onClick={() => setIsEditingName(true)}>{formData.nom}</h5>
            )}
          </div>
          {isImageOptionsVisible && (
            <div className="image-options">
              {imageOptions.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`image_option_${index}`}
                  onClick={() => handleImageOptionClick(imageUrl)}
                />
              ))}
            </div>
          )}
          <button type="submit" className="btn-lecture">
            Modifier le profil
          </button>
        </form>
        <p>{message}</p>
      </div>
    </section>
  );
}

export default ProfileDetails;
